const foundWidgets = new Set();

const observer = new MutationObserver((mutations, obs) => {
	const widgets = document.querySelectorAll("access-widget-ui[data-acsb]");

	widgets.forEach((widget) => {
		if (!foundWidgets.has(widget)) {
			foundWidgets.add(widget);

			if (widget.shadowRoot) {
				const trigger = widget.shadowRoot.querySelector(
					'[part="acsb-trigger"]'
				);
				if (trigger) {
					trigger.style.zIndex = "calc(var(--z-index-header) - 1)";
				}
			}
		}
	});
});

// Start observing
observer.observe(document.body, { childList: true, subtree: true });

// Stop observing after 10 seconds (adjust as needed)
setTimeout(() => {
	observer.disconnect();
	console.log("Stopped observing DOM for access-widget-ui elements.");
}, 10000);
